"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.handleLoanCalculator = void 0;
// @ts-nocheck
//@TODO need to check typescript warnings
var moment_1 = __importDefault(require("moment"));
var lodash_1 = __importDefault(require("lodash"));
var effective_interest_rate_1 = __importDefault(require("effective-interest-rate"));
var numberHelpers_1 = require("./numberHelpers");
var APR_DATE_FORMAT = 'YYYY-MM-DD';
var REML_NEWTON_RAPHSON_GUESS = 0.4;
var DAYS_IN_YEAR = 365;
var DECIMALS = 2;
var loanCalculatorREML = /** @class */ (function () {
    function loanCalculatorREML(amount, annualRate, serviceFeeRate, duration) {
        this.mathRound = function (num) {
            return Math.round(num * 100) / 100;
        };
        this._amount = amount;
        this._annualRate = annualRate;
        this._maxDuration = duration;
        this._guess = REML_NEWTON_RAPHSON_GUESS;
        this._duration = duration;
        this._serviceFeeRate = serviceFeeRate;
    }
    // Implementation of Excel IMPT and PPMT functions
    loanCalculatorREML.prototype.IMPT_PPMT = function (rate, period, periods, present, future, type) {
        if (future === void 0) { future = 0; }
        if (type === void 0) { type = 0; }
        // Compute payment
        var payment = this.PMT(rate, periods, present, future, type);
        // Compute interest
        var interest = this._getInterest(rate, period, type, present, payment);
        // calculate impt
        var impt = interest * rate;
        var ppmt = payment - impt;
        return { impt: impt, ppmt: ppmt };
    };
    // Implementation of Excel FV function
    loanCalculatorREML.prototype.FV = function (rate, periods, payment, value, type) {
        if (value === void 0) { value = 0; }
        if (type === void 0) { type = 0; }
        // Return future value
        if (rate === 0) {
            return -(value + payment * periods);
        }
        var term = Math.pow(1 + rate, periods);
        if (type === 1) {
            return -(value * term + (payment * (1 + rate) * (term - 1)) / rate);
        }
        return -(value * term + (payment * (term - 1)) / rate);
    };
    // Implementation of Excel PMT function
    loanCalculatorREML.prototype.PMT = function (rate, periods, present, future, type) {
        if (future === void 0) { future = 0; }
        if (type === void 0) { type = 0; }
        // Return payment
        if (rate === 0) {
            return -((present + future) / periods);
        }
        else {
            var term = Math.pow(1 + rate, periods);
            if (type === 1) {
                return -(((future * rate) / (term - 1) +
                    (present * rate) / (1 - 1 / term)) /
                    (1 + rate));
            }
            else {
                return -((future * rate) / (term - 1) +
                    (present * rate) / (1 - 1 / term));
            }
        }
    };
    loanCalculatorREML.prototype._getInterest = function (rate, period, type, present, payment) {
        if (period === 1) {
            if (type === 1) {
                return 0;
            }
            return -present;
        }
        else {
            if (type === 1) {
                return this.FV(rate, period - 2, payment, present, 1) - payment;
            }
            return this.FV(rate, period - 1, payment, present, 0);
        }
    };
    loanCalculatorREML.prototype.calculateAppropriateAmount = function (max_monthly_payment) {
        var today = moment_1.default();
        var _a = this._getNextPaymentDate(today, 0), days = _a[1];
        var term = Math.pow(1 + this._annualRate / 1200, this._maxDuration);
        var amount = max_monthly_payment /
            (((this._serviceFeeRate / DAYS_IN_YEAR) * Number(days)) / 100 +
                this._annualRate / 1200 / (1 - 1 / term));
        return this.mathRound(amount, 0);
    };
    loanCalculatorREML.prototype.generateSchedule = function () {
        var _this = this;
        var r = lodash_1.default.range(1, this._maxDuration + 1);
        var today = moment_1.default();
        var baseBalance = this._amount;
        return r
            .reduce(function (acc, m, i) {
            var _a;
            var _b = _this._getNextPaymentDate(today, i), nextPaymentDate = _b[0], days = _b[1];
            var lastBalance = i === 0 ? _this._amount : (_a = acc[i - 1]) === null || _a === void 0 ? void 0 : _a.balance;
            var _c = _this.IMPT_PPMT(_this._annualRate / 1200, i + 1, _this._duration, -_this._amount), serviceFeePlain = _c.impt, baseRaw = _c.ppmt;
            var serviceFeeInterest = _this._percentage(lastBalance, (_this._serviceFeeRate / DAYS_IN_YEAR) * Number(days));
            var serviceFee = serviceFeePlain + serviceFeeInterest;
            // For last month we just take the principal balance
            if (i === _this._maxDuration - 1) {
                baseBalance = _this.mathRound(baseBalance);
                baseRaw = baseBalance;
            }
            else {
                baseBalance -= _this.mathRound(baseRaw);
            }
            var paymentRaw = baseRaw + serviceFee;
            var balance = lastBalance - baseRaw;
            acc.push({
                baseRaw: baseRaw,
                serviceFeePlain: serviceFeePlain,
                serviceFeeInterest: serviceFeeInterest,
                serviceFee: serviceFee,
                balance: balance,
                paymentRaw: paymentRaw,
                date: nextPaymentDate,
            });
            return acc;
        }, [])
            .map(function (r) {
            var balance = (r === null || r === void 0 ? void 0 : r.balance) < 0.5 ? 0 : _this.mathRound(r === null || r === void 0 ? void 0 : r.balance);
            return __assign(__assign({}, r), { balance: balance, base: _this.mathRound(r.baseRaw), baseRaw: r.baseRaw, serviceFeePlain: _this.mathRound(r.serviceFeePlain), serviceFeeInterest: _this.mathRound(r.serviceFeeInterest), serviceFee: _this.mathRound(r.serviceFee), payment: _this.mathRound(r.paymentRaw), paymenRaw: r.paymentRaw });
        });
    };
    loanCalculatorREML.prototype.calculateAPR = function (now, withdrawalFeeAmount) {
        if (withdrawalFeeAmount === void 0) { withdrawalFeeAmount = 0; }
        var schedule = this.generateSchedule();
        var payments = lodash_1.default.reduce(schedule, function (result, value) {
            var _a;
            return lodash_1.default.merge(result, (_a = {},
                _a[value.date.format(APR_DATE_FORMAT)] = value.payment,
                _a));
        }, {});
        var aprRate = effective_interest_rate_1.default.withSpecifiedPayments(this._amount - withdrawalFeeAmount, now, payments, this._guess);
        return this._decimalPoints(aprRate * 100);
    };
    loanCalculatorREML.prototype._getTotal = function (schedule) {
        var total = schedule.reduce(function (sum, m) { return sum + m.paymenRaw; }, 0);
        return this.mathRound(total);
    };
    loanCalculatorREML.prototype._getNextPaymentDate = function (today, i) {
        var currentDate = today.clone().add(i, 'months');
        var nextPaymentDate = today.clone().add(i + 1, 'months');
        var days = nextPaymentDate.diff(currentDate, 'days');
        return [nextPaymentDate, days];
    };
    loanCalculatorREML.prototype._percentage = function (amount, p) {
        return (amount * p) / 100;
    };
    loanCalculatorREML.prototype._decimalPoints = function (number, decimals) {
        if (decimals === void 0) { decimals = DECIMALS; }
        var rounded = number.toFixed(decimals);
        return Number(rounded);
    };
    return loanCalculatorREML;
}());
exports.default = loanCalculatorREML;
var handleLoanCalculator = function (price, prepayment, percent, monthly_duration) {
    var _a;
    var amount = Number(price) - (Number(price) * Number(prepayment)) / 100;
    var max_monthly_duration = 240;
    var loanCalculator = new loanCalculatorREML(amount, Number(percent), 0.3, monthly_duration < max_monthly_duration
        ? monthly_duration
        : max_monthly_duration);
    if (amount < 0) {
        return '';
    }
    if (((_a = loanCalculator.generateSchedule()[0]) === null || _a === void 0 ? void 0 : _a.payment) && amount > 0)
        return numberHelpers_1.numberToDecimalString(Math.ceil(loanCalculator.generateSchedule()[0].payment));
    //@TODO this function calculates appropriate amount
    // loanCalculator.calculateAppropriateAmount(400000 * 0.4);
};
exports.handleLoanCalculator = handleLoanCalculator;
